import { KeyedArray, SortTypeEnum } from "@repo/models";
import { IncidentStatus } from "@repo/models";
import { GridBaseProps } from "@repo/ui";
import { Checkbox, Column, DateColumn, FiltersV2, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";
import { useMemo, useState } from "react";

import type { Complaint } from "../../../models";

import { useComplaintQueries } from "../../../api/complaintApi";
import { ComplaintsTypeGrid } from "./complaintsTypeGrid";

interface Props extends GridBaseProps<Complaint> {}

const COLUMNS = [
	new Column("Complaint ID", "complaintId"),
	new DateColumn("Incident Date", "incidentDate").dateOnly().withSortBy(SortTypeEnum.descending),
	new Column("Status", "status").withFormat((i) => IncidentStatus[i]),
	new Column("Customer Name", "customerName"),
	new Column("Account Number", "customerAccountNumber"),
	new Column("Complaint Type", "complaintTypeDescription"),
	new Column("Incident Category", "complaintOrIncidentString"),
	new Column("Incident Source", "complaintSourceDescription"),
	new OriginalTimezoneDateColumn("Completed Date", "completedDate").dateOnly(),
	new Column("Action Taken", "actionTakenName"),
	new DateColumn("Created On", "createdOn"),
] as Column<Complaint>[];

function ComplaintsGridBasic(props: Props) {
	const { useComplaintQuery } = useComplaintQueries();
	const { data, loaded, clearQuery } = useComplaintQuery();
	const [valid, setValid] = useState(false);
	const filteredData = useMemo(() => {
		if (!data?.any()) return new KeyedArray<Complaint>([], (i) => i.id);
		return data.filter((i) => !valid || i.valid === valid);
	}, [data, valid]);

	return (
		<>
			{renderFilters()}
			<GridPreLoaded
				{...props}
				id="cmplGrid"
				pageSize={5}
				columns={COLUMNS}
				values={filteredData.data}
				loading={!loaded}
				getData={clearQuery}
			/>
			<ComplaintsTypeGrid />
		</>
	);

	function renderFilters() {
		return (
			<FiltersV2 className="mt-2">
				<Checkbox label="Valid Only" value={valid} changeHandler={setValid} inline={false} />
			</FiltersV2>
		);
	}
}

export default ComplaintsGridBasic;
